import { useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import userManager from "../../util/userManager";
import { useLocation } from "react-router-dom";
import { redirectHelpers } from "../../util/helpers";

const LoginPage = (props: any) => {
	const { oidc_user } = props;
	const dispatch = useAppDispatch();
	const location = useLocation();

	// The custom login page is no longer being used - just wait to see if the user is already logged in
	// if so, redirect to the dashboard - if not, redirect to the IDP login page
	useEffect(() => {
		// Give a loading buffer for oidc user state
		const loggedInCheck = setTimeout(() => {
			clearTimeout(loggedInCheck);
			if (oidc_user) {
				const redirectUrl = redirectHelpers.retrieve();
				if (redirectUrl) {
					redirectHelpers.clear();
					if (redirectHelpers.isValidRedirectUrl(redirectUrl)) {
						dispatch(push(redirectUrl));
					} else {
						dispatch(push("/"));
					}
				} else {
					dispatch(push("/"));
				}
			} else {
				if (location.pathname && location.pathname !== '/login') {
					const fullUrl = location.pathname + location.search;
					redirectHelpers.store(fullUrl);
				}
				userManager.signinRedirect();
			}
		}, 1);
	}, [location.pathname, location.search]);

	return <></>;
};

function mapStateToProps(state: RootState) {
	return {
		oidc_user: state.oidc.user,
	};
}

function mapDispatchToProps(dispatch: AppDispatch) {
	return {
		dispatch,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
